import React from 'react'
import "../styles/hotAccessoriesMenu.css"
import { Link } from "react-router-dom"

const HotAccesssoriesMenu = () => {
  return (
    <div className='HotAccesssoriesMenu' >
      <Link className="HotAccesssoriesLink" to="/music" >Music Store</Link>
      <Link className="HotAccesssoriesLink" to="/smartDevice" >Smart Devices</Link>
      <Link className="HotAccesssoriesLink" to="/home" >Home</Link>
      <Link className="HotAccesssoriesLink" to="/lifestyle" >Lifestyle</Link>
      <Link className="HotAccesssoriesLink" to="/MobileAccessories" >Mobile Accessories</Link>
    </div>
  )
}

export default HotAccesssoriesMenu
